import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {FieldArray} from 'formik';
import FieldInputTypeahead from '../FieldInputTypeahead';
import CustomerItem from '../CustomerItem';
import FieldInput from '../FieldInput';
import {getCustomerDetails} from '../../utils/getCustomerDetails';
import ButtonCommon from '../ButtonCommon';
import Empty from '../Empty';
import * as actions from '../../actions/findCustomer';
import deleteIcon from '../../assets/delete-24px.svg';
import styles from './styles.module.scss';

const FieldFindCustomers = ({
                              formik,
                              name,
                              label,
                              readOnlyMode = false,
                            }) => {
  const dispatch = useDispatch();
  const {values} = formik;
  const [inputValue, setInputValue] = useState('');

  const findCustomer = (input) => {
    return dispatch(actions.findCustomer(input));
  };
  const customerNotInList = (customer, values) => {
    const ids = values.customers.map(item => item.customerID);
    return ids.indexOf(customer.customerID) === -1;
  };
  const handleAddCustomerToList = ({values, value, add}) => {
    if (value && customerNotInList(value, values)) {
      add(value);
    }
  };
  const handleChange = (add) => (value) => {
    handleAddCustomerToList({
      values,
      value,
      add,
    })
  }

  return (
    <div>
      <FieldArray name={name}>
        {({unshift, remove}) => {
          return (
            <>
              {!readOnlyMode && (
                <FieldInputTypeahead
                  fieldId={'inputValue'}
                  value={inputValue}
                  isLoading={false}
                  labelKey={option => `${option.firstName} ${option.lastName}`}
                  makeAndHandleRequest={() => {
                  }}
                  onChange={handleChange(unshift)}
                  onInputChange={(e) => {
                    setInputValue(e.target.value);
                  }}
                  renderMenuItemChildren={option => <CustomerItem {...option}/>}
                  handleFindItem={findCustomer}
                  label={label}
                  setFieldValue={formik.setFieldValue}
                />
              )}
              <div className={styles.addedCustomersContainer}>
                {values.customers.length > 0
                  ?
                  (values.customers.map((customer, index) => (
                    <div className={styles.customerContainer} key={index}>
                      <FieldInput
                        fieldId={`customerDetails-${index}`}
                        customInputStyles={styles.input}
                        readonly="readonly"
                        disabled
                        value={getCustomerDetails(customer)}
                      />
                      {!readOnlyMode && (
                        <ButtonCommon
                          onClick={() => remove(index)}
                          label={
                            <div className={styles.flex}>
                              <img src={deleteIcon} alt="remove"/>
                              <span>הסרה</span>
                            </div>
                          }
                          customContainerStyles={styles.marginRight}
                        />
                      )}
                    </div>
                  )))
                  : <Empty message={'לא נוספו לקוחות'} customContainerClassName={styles.emptyContainer}/>
                }
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

FieldFindCustomers.propTypes = {
  formik: PropTypes.object,
  customContainerStyles: PropTypes.string,
  customItemStyles: PropTypes.string,
  readOnlyMode: PropTypes.bool,
};

export default FieldFindCustomers;
